export interface MVItem {
  id: number;
  title: string;
  artist: string;
  category: string;
  coverImage: string;
  views: string;
  description: string;
  releaseDate: string;
  duration: string;
  tags: string[];
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: CategoryItem[] = [
  { slug: 'pop', name: '流行', icon: 'ri-music-line', description: '全球流行音乐最新MV，汇聚Billboard Hot 100热门单曲' },
  { slug: 'rock', name: '摇滚', icon: 'ri-flashlight-line', description: '经典与独立摇滚MV，感受吉他与鼓点的力量' },
  { slug: 'hiphop', name: '嘻哈', icon: 'ri-headphone-line', description: '最火嘻哈说唱MV，追踪Trap与Boom Bap新作' },
  { slug: 'electronic', name: '电子', icon: 'ri-cpu-line', description: '电子音乐视觉盛宴，EDM、House、Techno精选' },
  { slug: 'rnb', name: '节奏蓝调', icon: 'ri-heart-pulse-line', description: '灵魂R&B与现代节奏蓝调MV赏析' },
  { slug: 'latin', name: '拉丁', icon: 'ri-sun-line', description: '热情拉丁音乐MV，Reggaeton与Latin Pop热门' },
];

export const mvs: MVItem[] = [
  {
    id: 1,
    title: 'Flowers',
    artist: 'Miley Cyrus',
    category: 'pop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20music%20video%20still%20of%20a%20female%20singer%20in%20a%20golden%20vintage%20mansion%20with%20warm%20lighting%2C%20retro%20aesthetic%2C%20soft%20glamour%2C%20cinematic%20shot%2C%20warm%20amber%20tones%2C%20elegant%20atmosphere&width=800&height=450&seq=mv-cover-01&orientation=landscape',
    views: '8.2亿',
    description: 'Miley Cyrus的全球热单《Flowers》MV，以复古风格展现了独立女性的力量与自信。MV中Miley在金色豪宅中独舞，传递出自爱和独立的精神内核。',
    releaseDate: '2023-01-13',
    duration: '3:21',
    tags: ['Billboard Hot 100', '格莱美', '年度金曲']
  },
  {
    id: 2,
    title: 'As It Was',
    artist: 'Harry Styles',
    category: 'pop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cinematic%20music%20video%20scene%20with%20a%20male%20singer%20on%20a%20rotating%20platform%20in%20vibrant%20red%20outfit%2C%20colorful%20studio%20lighting%2C%20artistic%20visual%2C%20warm%20color%20palette%2C%20dynamic%20composition&width=800&height=450&seq=mv-cover-02&orientation=landscape',
    views: '7.1亿',
    description: 'Harry Styles的回归之作《As It Was》MV，以旋转舞台和鲜艳色彩营造梦幻氛围。歌曲探讨了变化、孤独与个人成长的主题。',
    releaseDate: '2022-04-01',
    duration: '2:47',
    tags: ['UK Singles Chart', '年度热单', '英伦流行']
  },
  {
    id: 3,
    title: 'Kill Bill',
    artist: 'SZA',
    category: 'rnb',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cinematic%20music%20video%20inspired%20by%20martial%20arts%20film%20with%20a%20female%20artist%20in%20yellow%20jumpsuit%2C%20action%20scene%2C%20warm%20cinematic%20lighting%2C%20dramatic%20composition%2C%20film%20grain%20texture&width=800&height=450&seq=mv-cover-03&orientation=landscape',
    views: '5.8亿',
    description: 'SZA的《Kill Bill》MV致敬经典功夫电影，以黄色连体衣造型致敬《杀死比尔》。歌曲将R&B与复仇叙事巧妙结合，创造出独特的视听体验。',
    releaseDate: '2023-01-10',
    duration: '2:35',
    tags: ['R&B', 'Billboard', '年度专辑']
  },
  {
    id: 4,
    title: 'Blinding Lights',
    artist: 'The Weeknd',
    category: 'pop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20neon-lit%20night%20city%20scene%20with%20a%20man%20in%20red%20suit%20running%20through%20empty%20streets%2C%20synthwave%20aesthetic%2C%2080s%20retro%20vibe%2C%20warm%20neon%20glow%2C%20cinematic%20noir%20atmosphere&width=800&height=450&seq=mv-cover-04&orientation=landscape',
    views: '6.5亿',
    description: 'The Weeknd的《Blinding Lights》MV延续了80年代合成器流行美学，夜幕下的都市追逐场景配合霓虹光影，营造出迷离梦幻的复古氛围。',
    releaseDate: '2020-01-21',
    duration: '3:22',
    tags: ['Synthwave', '80年代复古', 'Billboard纪录']
  },
  {
    id: 5,
    title: 'Paint The Town Red',
    artist: 'Doja Cat',
    category: 'hiphop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20bold%20music%20video%20scene%20with%20a%20female%20rapper%20surrounded%20by%20floating%20red%20paint%20and%20surreal%20elements%2C%20dark%20background%2C%20striking%20visual%20contrast%2C%20artistic%20composition%2C%20warm%20red%20accents&width=800&height=450&seq=mv-cover-05&orientation=landscape',
    views: '4.9亿',
    description: 'Doja Cat的《Paint The Town Red》MV以超现实艺术风格呈现，红色作为主色调贯穿始终。歌曲展现了Doja在说唱领域的强大自信与创作力。',
    releaseDate: '2023-08-04',
    duration: '3:15',
    tags: ['说唱', 'Billboard冠军', '超现实']
  },
  {
    id: 6,
    title: 'Good 4 U',
    artist: 'Olivia Rodrigo',
    category: 'rock',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20high-energy%20cheerleader-themed%20music%20video%20with%20a%20young%20female%20singer%20in%20dark%20aesthetic%2C%20fire%20elements%2C%20dramatic%20lighting%2C%20punk%20rock%20influence%2C%20warm%20flame%20tones&width=800&height=450&seq=mv-cover-06&orientation=landscape',
    views: '5.1亿',
    description: 'Olivia Rodrigo的《Good 4 U》MV融合啦啦队元素与朋克摇滚美学，火焰与暗黑氛围营造出叛逆青春气息。歌曲成为2021年最热门摇滚单曲之一。',
    releaseDate: '2021-05-14',
    duration: '2:58',
    tags: ['流行朋克', '青春摇滚', '年度新人']
  },
  {
    id: 7,
    title: 'Unholy',
    artist: 'Sam Smith & Kim Petras',
    category: 'pop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20theatrical%20music%20video%20set%20in%20a%20dark%20cabaret%20club%20with%20performers%20in%20extravagant%20costumes%2C%20red%20velvet%20curtains%2C%20warm%20spotlight%2C%20burlesque%20atmosphere&width=800&height=450&seq=mv-cover-07&orientation=landscape',
    views: '4.3亿',
    description: 'Sam Smith与Kim Petras合作的《Unholy》MV以暗黑歌舞厅为背景，华丽的服装设计和戏剧化的表演营造出大胆前卫的视觉风格。',
    releaseDate: '2022-09-22',
    duration: '2:37',
    tags: ['格莱美', '合作金曲', '戏剧化']
  },
  {
    id: 8,
    title: 'Super Shy',
    artist: 'NewJeans',
    category: 'pop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20bright%20youthful%20music%20video%20with%20a%20group%20of%20girls%20dancing%20in%20a%20colorful%20street%20market%2C%20pastel%20tones%2C%20natural%20daylight%2C%20fresh%20and%20fun%20atmosphere%2C%20warm%20summer%20vibe&width=800&height=450&seq=mv-cover-08&orientation=landscape',
    views: '3.8亿',
    description: 'NewJeans的《Super Shy》MV以清新街头风格呈现，少女们在市集和街头自由舞蹈，传递出青春活力与纯真美好。Y2K美学贯穿全片。',
    releaseDate: '2023-07-07',
    duration: '2:34',
    tags: ['K-Pop', 'Y2K美学', '夏日热单']
  },
  {
    id: 9,
    title: 'Industry Baby',
    artist: 'Lil Nas X',
    category: 'hiphop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20bold%20prison-themed%20music%20video%20with%20a%20male%20rapper%20in%20pink%20prison%20uniform%2C%20dance%20choreography%2C%20satirical%20tone%2C%20vibrant%20warm%20colors%2C%20high%20production%20value&width=800&height=450&seq=mv-cover-09&orientation=landscape',
    views: '5.5亿',
    description: 'Lil Nas X的《Industry Baby》MV以监狱为背景，大胆挑战传统观念，配合精湛的舞蹈编排和幽默叙事，成为近年来最具话题性的MV之一。',
    releaseDate: '2021-07-23',
    duration: '3:32',
    tags: ['说唱', '话题之作', 'MTV大奖']
  },
  {
    id: 10,
    title: 'Tití Me Preguntó',
    artist: 'Bad Bunny',
    category: 'latin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Latin%20music%20video%20with%20a%20male%20singer%20at%20a%20colorful%20block%20party%2C%20dancing%20crowd%2C%20tropical%20atmosphere%2C%20bright%20warm%20colors%2C%20festive%20energy%2C%20Caribbean%20aesthetic&width=800&height=450&seq=mv-cover-10&orientation=landscape',
    views: '6.2亿',
    description: 'Bad Bunny的《Tití Me Preguntó》MV展现了拉丁街区的热情派对场景，融合Reggaeton节奏与加勒比文化元素，派对氛围感十足。',
    releaseDate: '2022-05-06',
    duration: '4:04',
    tags: ['Latin Grammy', 'Reggaeton', '拉丁天王']
  },
  {
    id: 11,
    title: 'Bad Habit',
    artist: 'Steve Lacy',
    category: 'rnb',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20lo-fi%20aesthetic%20music%20video%20with%20a%20male%20musician%20in%20a%20cozy%20bedroom%20studio%2C%20warm%20lamplight%2C%20vintage%20decor%2C%20intimate%20atmosphere%2C%20retro%20color%20grading%2C%20nostalgic%20feel&width=800&height=450&seq=mv-cover-11&orientation=landscape',
    views: '3.2亿',
    description: 'Steve Lacy的《Bad Habit》MV以低保真美学呈现，温暖的卧室录音室氛围配合复古色调，将独立R&B的魅力展现得淋漓尽致。',
    releaseDate: '2022-06-29',
    duration: '3:52',
    tags: ['独立R&B', 'Lo-fi', '突破单曲']
  },
  {
    id: 12,
    title: 'Anti-Hero',
    artist: 'Taylor Swift',
    category: 'pop',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20surreal%20music%20video%20with%20a%20female%20singer%20in%20a%20dining%20room%20with%20multiple%20versions%20of%20herself%2C%20warm%20lighting%2C%20whimsical%20yet%20introspective%2C%20cinematic%20composition%2C%20rich%20amber%20tones&width=800&height=450&seq=mv-cover-12&orientation=landscape',
    views: '5.9亿',
    description: 'Taylor Swift的《Anti-Hero》MV以超现实手法展现多重自我的内心世界，餐桌上不同版本的Taylor相互对话，深刻探讨了自我认知与焦虑。',
    releaseDate: '2022-10-21',
    duration: '4:15',
    tags: ['Billboard冠军', '自省之作', '流行天后']
  },
];

export const getMVsByCategory = (slug: string): MVItem[] => {
  return mvs.filter(mv => mv.category === slug);
};

export const getMVById = (id: number): MVItem | undefined => {
  return mvs.find(mv => mv.id === id);
};

export const getRelatedMVs = (id: number, category: string, limit: number = 4): MVItem[] => {
  return mvs.filter(mv => mv.id !== id && mv.category === category).slice(0, limit);
};